import { gql } from "@apollo/client";

export const DELETE_BUDGETS = gql`
  mutation deleteBudgets($pId: ID!, $cId: ID!) {
    DeleteBudgets(pId: $pId, cId: $cId) {
      message
      success
      result
    }
  }
`;
